import { useDispatch } from 'react-redux';

import { NsSecondaryCta } from 'components/common/ns-secondary-cta/NsSecondaryCta';
import { setInitialState as resetEmailQuoteSlice } from 'state/email-quote/email-quote-slice';
import { useNavigation } from 'hooks/useNavigation';
import { useIsEmailQuoteQualified } from 'components/direct-sales/quote/hooks/useIsEmailQuoteQualified';

import type { TProduct } from 'api/models/TProduct';

type Props = {
  product?: TProduct;
};

export const EmailQuoteCta = ({ product }: Props) => {
  const dispatch = useDispatch();
  const isEmailQuoteQualified = useIsEmailQuoteQualified();
  const code = product?.code;
  const { eventTypes, next } = useNavigation();

  const handleClick = () => {
    dispatch(resetEmailQuoteSlice());
    next({
      eventType: eventTypes.EMAIL_QUOTE,
      routeParams: { productCode: `${code}` }
    });
  };

  if (!isEmailQuoteQualified) {
    return null;
  }

  return <NsSecondaryCta onClick={handleClick}>Decide later</NsSecondaryCta>;
};
